// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__1pN0z","logo":"MainNavigation_logo__2SBS6","nav":"MainNavigation_nav__2ozvM","active":"MainNavigation_active__1D3jv"};